var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"top":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v(_vm._s(_vm.current))])
}
var staticRenderFns = []

export { render, staticRenderFns }